export type ReactFiberKnownProperties = {
	elementType?: unknown;
	type?: unknown;
	tag?: number;
	return: ReactFiberKnownProperties | null;
	_debugSource?: {
		lineNumber: number;
		columnNumber: number;
		fileName: string;
	};
};

const isReactFiberInterestingProperties = (value: unknown): value is ReactFiberKnownProperties => {
	return Boolean(value && typeof value === 'object' && 'return' in value);
};

export const getReactFiberForElement = (element: Element): ReactFiberKnownProperties | null => {
	const fiberKey = Object.keys(element).find((key) => key.startsWith('__reactFiber'));
	if (!fiberKey) {
		return null;
	}
	const fiber = Reflect.get(element, fiberKey);
	return isReactFiberInterestingProperties(fiber) ? fiber : null;
};

export const getReturnStack = (fiber: ReactFiberKnownProperties): ReactFiberKnownProperties[] => {
	let next: ReactFiberKnownProperties | null = fiber;
	const result: ReactFiberKnownProperties[] = [];
	while (next) {
		result.push(next);
		next = next.return;
	}
	return result;
};

export const getNamedCandidate = (candidate: unknown): string | null => {
	if (typeof candidate === 'string') {
		return candidate;
	}
	if (typeof candidate === 'function') {
		// @ts-expect-error TS2339: Property displayName does not exist on type Function
		return candidate.displayName ?? candidate.name ?? null;
	}
	if (!candidate || typeof candidate !== 'object') {
		return null;
	}
	const maybeDisplayName = 'displayName' in candidate ? candidate.displayName : undefined;
	if (typeof maybeDisplayName === 'string' && maybeDisplayName.length > 0) {
		return maybeDisplayName;
	}
	const maybeName = 'name' in candidate ? candidate.name : undefined;
	if (typeof maybeName === 'string' && maybeName.length > 0) {
		return maybeName;
	}
	const maybeRender = 'render' in candidate ? candidate.render : undefined;
	if (typeof maybeRender === 'function') {
		// @ts-expect-error TS2339: Property displayName does not exist on type Function
		return maybeRender.displayName ?? maybeRender.name ?? null;
	}
	return null;
};

export const getFiberDisplayName = (fiber: ReactFiberKnownProperties): string | null => {
	return getNamedCandidate(fiber.elementType) ?? getNamedCandidate(fiber.type);
};

/**
 * a special export to "justify" the file name
 */
export const reactFiber: null = null;
